<template>
  <el-timeline class="lad-itinerary-section--days">
    <el-timeline-item
      v-for="(day, i) in days"
      :key="day.id"
      :class="{ 'hidden-day': limit < i + 1 }"
    >
      <template slot="dot">
        <span>{{ $tc(`${base}.day`, i, { day: i + 1 }) }}</span>
        <span class="arrow-right"></span>
        <span>{{ day | getTitle }}</span>
      </template>

      <LadItinerarySectionDay
        :day="day"
        :index="i"
        :title="$options.filters.getTitle(day)"
        :days-number="days.length"
      />
    </el-timeline-item>
  </el-timeline>
</template>

<script>
import LadItinerarySectionDay from './day'

export default {
  name: 'LadItinerarySectionDays',
  components: { LadItinerarySectionDay },
  filters: {
    getTitle: (day) => (day.times.length > 0 ? day.times[0].title : ''),
  },
  props: {
    days: { type: Array, default: () => [] },
    limit: { type: Number, default: 1 },
  },
  data() {
    return {
      base: 'components.itinerary.section',
    }
  },
}
</script>

<style lang="scss">
.lad-itinerary-section {
  & > .el-timeline {
    padding: 0;

    & > .el-timeline-item {
      padding: 0;

      &.hidden-day {
        display: none;
      }

      & > .el-timeline-item__tail,
      & > .el-timeline-item__timestamp {
        display: none;
      }

      & > .el-timeline-item__wrapper {
        padding-left: 0;
        top: 0;
      }

      & > .el-timeline-item__dot {
        background-color: #f9f9f9;
        justify-content: left;
        position: relative;
        display: grid;
        grid-template-columns: 100px auto 1fr;
        align-items: center;

        span {
          &.arrow-right {
            width: 15px;
          }

          &:first-child {
            background-color: #e2e2e2;
            text-align: center;
            line-height: 50px;
            font-weight: 700;
            padding: 0 1em;
            width: 100px;
          }

          &:last-child {
            padding: 0 0.8em;
            width: auto;
          }
        }
      }
    }
  }
}
</style>
